function LoadingOverlay({ isLoading, message = "Transforming your image..." }) {
  if (!isLoading) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md">
        <div className="relative w-24 h-24 mx-auto mb-6">
          <div className="absolute top-0 left-0 w-full h-full border-4 border-primary border-opacity-20 rounded-full"></div>
          <div className="absolute top-0 left-0 w-full h-full border-4 border-transparent border-t-primary rounded-full animate-spin"></div>
        </div>
        
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Please Wait</h3>
        <p className="text-gray-600">{message}</p>
        
        <div className="mt-6 h-3 bg-gray-200 rounded-full overflow-hidden">
          <div className="h-full bg-primary animate-pulse rounded-full"></div>
        </div>
        
        <p className="mt-4 text-sm text-gray-500">This may take up to 30 seconds...</p>
      </div>
    </div>
  );
}

export default LoadingOverlay; 